'use client'

import {useEffect} from 'react'
import Divider from './common/Divider'
import Typography from './common/Typography'
import Pin from '@svg/pin.svg'

export default function Footer() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/service-worker.js', {updateViaCache: 'none'})
        .then(reg => {
          console.log('✅ Service worker registered:', reg.scope)
          reg.update()
        })
        .catch(err => console.error('❌ Service worker registration failed:', err))
    }
  }, [])

  return (
    <footer className="h-auto max-w-full flex flex-col items-center justify-center gap-5 py-16 px-10 bg-black">
      <Typography size="lg2" className="text-white">
        xPayzMarket
      </Typography>
      <Typography size="md2" className="max-w-180 text-center text-sub-200!">
        xPayzMarket is a merchant commerce platform. Payments are processed through the Xpayz payment gateway.
      </Typography>
      <div className="flex flex-col lg:flex-row items-center gap-6">
        <div className="flex flex-row items-center">
          <Pin className="w-4 h-4 mr-2" />
          <a
            href="https://maps.app.goo.gl/VauxaqUoJYqe99K49"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer underline text-sub-200">
            Paysandu 1134 Rivera, Rivera,Uruguay Post code: 40000
          </a>
        </div>
        <Divider vertical className="hidden lg:flex" />
        <div className="flex flex-row items-center">
          <Pin className="w-4 h-4 mr-2" />
          <a
            href="https://maps.app.goo.gl/G2sAMVQArLRELLKNA"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer underline text-sub-200">
            Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, UAE
          </a>
        </div>
      </div>
      <Divider />
      <div className="flex gap-6 items-center text-sub-200">
        <a className="text-xs hover:underline" href="/terms">
          Terms
        </a>
        <Divider vertical />
        <a className="text-xs hover:underline" href="/privacy">
          Privacy
        </a>
        <Divider vertical />
        <a className="text-xs hover:underline" href="/contact">
          Contact
        </a>
      </div>
      <Typography size="xs" className="text-sub-300!">
        © {new Date().getFullYear()} <strong>GKS Solutions FZCO</strong>. All rights reserved.
      </Typography>
      <Typography size="xs" className="text-sub-300!">
        <strong>xPayzMarket</strong> and related names, logos, and branding are trademarks or trade dress of{' '}
        <strong>GKS Solutions FZCO</strong>.
      </Typography>
    </footer>
  )
}
